import * as PurchaseTableColumns from "../purchase/PurchaseTableColumnsDefinition";
import * as MaintenanceTableColumns from "../maintenance/MaintenanceTableColumnsDefinition";
import * as IndirectTableColumns from "../indirect/IndirectTableColumnsDefinitions";
import * as CollateralTableColums from "../collateral/CollateralTableColumnsDefinition";
import * as TelematicsTableColums from "../telematics/TelematicsTableColumnsDefinition";
// import * as FileSaver from 'file-saver';
// import * as XLSX from 'xlsx';

//General methods
const convertArrayOfObjectsToCSV = (array, config) => {
    let result
    if (array.length === 0) {
        return
    }
    const columnDelimiter = ','
    const lineDelimiter = '\n'
    const keys = config ? config.map(function (a) { return a.selector }) : Object.keys(array[0])
    result = ''
    result += config ? config.map(function (a) { return a.label }).join(',') : keys.join(columnDelimiter)
    result += lineDelimiter

    array.forEach(item => {
        let ctr = 0
        keys.forEach(key => {
            if (config && config.find(x => x.selector === key)) {
                if (ctr > 0)
                    result += columnDelimiter
                if (Array.isArray(item[key])) {
                    var propToJoin = config.find(x => x.selector === key).propToJoin
                    result += item[key].map(function (a) { return a[propToJoin] }).join(' ; ')
                } else if (item[key] === null) {
                    result += ''
                } else {
                    switch (key) {
                        case 'currencyId': //Indirect - 
                            result += item[key].toString().replace(/,/g, ' ') === 1 ? 'USD' : 'MXN'
                            break
                        case 'invoiceStatus': //Indirect - 
                            result += showStatusInvoiceText(item[key].toString().replace(/,/g, ' '))
                            break
                        case 'lagTime': //Indirect - 
                            result += item[key].toString().replace(/,/g, ' ') <= 30 ? '30 días' : '+30 días'
                            break
                        case 'Concluida': //Indirect - 
                            result += 'Completado'
                            break
                        case 'invoiceType':
                            result += showInvoiceTypeText(item[key].toString().replace(/,/g, ' '))
                            break
                        default:
                            result += item[key].toString().replace(/,/g, ' ')
                            break
                    }
                }
                ctr++
            } else {
                if (ctr > 0)
                    result += columnDelimiter
                result += item[key].toString().replace(/,/g, ' ')
                ctr++;
            }
        })
        result += lineDelimiter
    })
    return result
}

export const downloadCSV = (array, config, status = '') => {

    const link = document.createElement('a');
    let csv = convertArrayOfObjectsToCSV(array, config);
    if (csv == null) return;

    let filename = 'export.csv';
    switch (status) {
        case '27':
            filename = 'Pago_pendiente.csv'
            break;
        case '28':
            filename = 'Pagadas_rechazadas.csv'
            break;
        default:
            filename = 'export.csv'
            break;
    }
    // if (!csv.match(/^data:text\/csv/i)) {
    //     csv = `data:text/csv;charset=utf-8,${csv}`;
    // }

    link.setAttribute('href', 'data:text/csv;charset=utf-8,\uFEFF' + encodeURI(csv));
    link.setAttribute('download', filename);
    link.click();

    //TO DO

    // const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    // const fileExtension = '.xlsx';
    // const fileName = 'file'

    // const ws = XLSX.utils.json_to_sheet(array);
    // const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    // const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    // const data = new Blob([excelBuffer], { type: fileType });
    // FileSaver.saveAs(data, fileName + fileExtension);
}

export const downloadCSVCustomName = (array, config, name) => {
    const link = document.createElement('a');
    let csv = convertArrayOfObjectsToCSV(array, config);
    if (csv == null) return;

    const filename = name + '.csv';

    link.setAttribute('href', 'data:text/csv;charset=utf-8,\uFEFF' + encodeURI(csv));
    link.setAttribute('download', filename);
    link.click();

}

export const downloadCSVOtherStatus = (array, config, status) => {
    const link = document.createElement('a');
    let csv = convertArrayOfObjectsToCSV(array, config);
    if (csv == null) return;

    let filename = 'export.csv';

    if(status=='9')
    {
     filename = 'Rechazadas.csv';
    }
    else if(status =='12')
   {
    filename = 'En_proceso_de_pago.csv';
   }
   else if(status =='15')
   {
    filename = 'Pagadas.csv';
   }

    link.setAttribute('href', 'data:text/csv;charset=utf-8,\uFEFF' + encodeURI(csv));
    link.setAttribute('download', filename);
    link.click();

}

export const handleGeneralFileTypes = (event, option) => {
    let file = event.target.files[0]
    if (file != null) {
        let types = []

        switch (option) {
            case "xml":
                types = ['text/xml']
                break;
            case 'pdf':
                types = ['application/pdf']
                break;
            case 'right':
                types = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg']
                break;
            default:
                break;
        }
        if (types.every(type => file.type !== type)) {
            return false
        } else {
            return true
        }
    }
}
export const showInvoiceTypeText = (invoiceType) => {
    switch (invoiceType) {
        case ('VE'):
            return ('Vehículo')
        case ('NC'):
            return ('Nota de crédito')
        case ('AC'):
        case ('ACNOT'):
            return ('Accesorio')
        default:
            return ('Trámite')
    }
}

export const showStatusInvoiceText = (invoiceStatus) => {
    switch (invoiceStatus) {
        case ('0'):
            return ('Sin Factura')
        case ('17'):
            return ('Factura Recibida')
        case ('25'):
            return ('Rechazada por AP')
        case ('27'):
            return ('Pendiente de Pago')
        case ('28'):
            return ('Pagada')
        case ('29'):
            return ('Pagada Parcialmente')
        case ('31'):
            return ('En Propuesta de Pago')
        case ('73'):
            return ('En proceso de pago')
        case ('74'):
            return ('En proceso de pago')
        case ('75'):
            return ('En proceso de pago')
        case ('80'):
            return ('PAGADO')
        case ('81'):
            return ('CANCELADO')
        default:
            return invoiceStatus
    }
}

export const FormatNumberMXN = (number) => {
    return new Intl.NumberFormat('ES-MX', { style: 'currency', currency: 'MXN' }).format(number)
}

export const formatNumber = number => {
    return new Intl.NumberFormat('ES-MX').format(number)
};

//Titles and columns to Tables
export const getFilteredTableTitle = (module, status) => {
    switch (module) {
        case "Purchase":
            switch (status) {
                case '0':
                    return 'OC Asignadas'
                case '25':
                    return 'OC Factura Rechazada'
                case '17':
                    return 'OC Factura Recibida'
                case '27':
                    return 'OC Facturas Pendientes de pago'
                case '28':
                    return 'OC Facturas Pagadas / Rechazadas'
                case '-1':
                    return 'OC Canceladas por NVP'
                default:
                    return
            }
        case "Maintenance":
            switch (status) {
                case '0':
                    return 'Todas las órdenes'
                case '3':
                    return 'Autorizaciones sin Factura'                
                case '6':
                    //return 'Autorizaciones en revisión de pago'
                    return 'Autorizaciones con Factura'
                case '20':
                    return 'Autorizaciones Canceladas'
                case '12':
                    return 'Autorizaciones en proceso de pago'
                case '15':
                    return 'Autorizaciones Pagadas'
                default:
                    return
            }
        case "Indirect":
            switch (status) {
                case '2':
                    return 'Solicitudes de compra sin factura'
                case '27':
                    return 'Solicitudes de compra con factura recibida'
                case '5':
                    return 'Solicitudes de compra rechazadas'
                case '11':
                    return 'Solicitudes de compra no pagadas'
                case '14':
                    return 'Solicitudes de compra pagadas'
                default:
                    return
            }
        default:
            break;
    }
}

export const getTableColumns = (module, status) => {
    switch (module) {
        case "Purchase":
            switch (status) {
                case '0':
                    return PurchaseTableColumns.ColumnsForStatusAssigned
                default:
                    return PurchaseTableColumns.ColumnsForStatusAssigned
            }
        case "Maintenance":
            switch (status) {
                case '0':
                    return MaintenanceTableColumns.ColumnsForAllOrders
                case '3':
                    return MaintenanceTableColumns.ColumnsForStatusWithOutInvoice
                case '20':
                    return MaintenanceTableColumns.ColumnsForStatusCancelled
                case '6':
                    return MaintenanceTableColumns.ColumnsForStatusPaymentReview                
                case '12':
                    return MaintenanceTableColumns.ColumnsForStatusPaymentProcess
                case '15':
                    return MaintenanceTableColumns.ColumnsForStatusPayed
                default:
                    return
            }
        case "Indirect":
            switch (status) {
                case '2':
                    return IndirectTableColumns.WithoutInvoice
                case '27':
                    return IndirectTableColumns.WithInvoice
                case '5':
                    return IndirectTableColumns.RejectedByAp
                case '11':
                    return IndirectTableColumns.Paid
                case '14':
                    return IndirectTableColumns.Unpaid
                default:
                    return
            }


        default:
            break;
    }
}

export const getTableColumnsByStage = (module, stage, lang) => {
    switch (module) {
        case "Collateral":
            switch (stage) {
                case 'ProcesoATiempo': {
                    switch (lang) {
                        case 'en':
                            return CollateralTableColums.ColumnsForProcessOnTimeEng
                        case 'es':
                            return CollateralTableColums.ColumnsForProcessOnTimeSpa
                        default:
                            return
                    }
                }
                case 'ProcesoFueraDeTiempo': {
                    switch (lang) {
                        case 'en':
                            return CollateralTableColums.ColumnsForProcessOutOfTimeEng
                        case 'es':
                            return CollateralTableColums.ColumnsForProcessOutOfTimeSpa
                        default:
                            return
                    }
                }
                case 'Tramite': {
                    switch (lang) {
                        case 'en':
                            return CollateralTableColums.ColumnsForReceptionProcessEng
                        case 'es':
                            return CollateralTableColums.ColumnsForReceptionProcessSpa
                        default:
                            return;
                    }
                }
                case 'Comprobacion': {
                    switch (lang) {
                        case 'en':
                            return CollateralTableColums.ColumnsForComprobationEng
                        case 'es':
                            return CollateralTableColums.ColumnsForComprobationSpa
                        default:
                            return;
                    }
                }
                case 'PagoPendiente': {
                    switch (lang) {
                        case 'en':
                            return CollateralTableColums.ColumnsForPaymentOnDelayEng
                        case 'es':
                            return CollateralTableColums.ColumnsForPaymentOnDelaySpa
                        default:
                            return;
                    }
                }
                case 'Finalizacion': {
                    switch (lang) {
                        case 'en':
                            return CollateralTableColums.ColumnsForFinalizationEng
                        case 'es':
                            return CollateralTableColums.ColumnsForFinalizationSpa
                        default:
                            return;
                    }
                } default:
                    return
            }
        case "Telematics":
            switch (stage) {
                case 'ConProveedor': {
                    switch (lang) {
                        case 'en':
                            return TelematicsTableColums.ColumnsForNewOrderInstalationEng
                        case 'es':
                            return TelematicsTableColums.ColumnsForNewOrderInstalationSpa
                        default:
                            return
                    }
                }
                case 'EnProceso': {
                    switch (lang) {
                        case 'en':
                            return TelematicsTableColums.ColumnsForApprovedInstalationsEng
                        case 'es':
                            return TelematicsTableColums.ColumnsForApprovedInstalationsSpa
                        default:
                            return
                    }
                }
                case 'EnFacturacion': {
                    switch (lang) {
                        case 'en':
                            return TelematicsTableColums.ColumnsForPendingInvoiceEng
                        case 'es':
                            return TelematicsTableColums.ColumnsForPendingInvoiceSpa
                        default:
                            return
                    }
                }

                case 'Finalizada': {
                    switch (lang) {
                        case 'en':
                            return TelematicsTableColums.ColumnsForFinaliazedEng
                        case 'es':
                            return TelematicsTableColums.ColumnsForFinaliazedSpa
                        default:
                            return
                    }
                }
                default:
                    return
            }
        default:
            break;
    }
}

export const getUploadEvidenceTableTitle = (option) => {
    switch (option) {
        case "UnitPhotos":
            return "Fotos de Unidad"
        case "DocumentsPhotos":
            return "Fotos de documentos"
        case "Videos":
            return "Videos de evidencia"
        default:
            break;
    }
}

export const getUploadEvidenceTableColumns = (option, handleClickOpen) => {
    switch (option) {
        case "UnitPhotos":
            return MaintenanceTableColumns.ColumnsForUploadEvidenceUnitPhotos(handleClickOpen)
        case "DocumentsPhotos":
            return MaintenanceTableColumns.ColumnsForUploadEvidenceDocumentPhoto(handleClickOpen)
        case "Videos":
            return MaintenanceTableColumns.ColumnsForUploadEvidenceVideo(handleClickOpen)
        default:
            break;
    }
}

export const getUploadPurchaseEvidenceTableColumns = (disabled, option, handleClickDownload, handleClickDelete) => {
    switch (option) {
        case "PurchaseEvidence":
            return PurchaseTableColumns.ColumnsForUploadEvidence(disabled, handleClickDownload, handleClickDelete)
        default:
            break;
    }
}

export const getOtherInvoiceTableColumnSpa = (handleClickDownload, handleDelete) => {
    return PurchaseTableColumns.ColumnsForOtherInvoice(handleClickDownload, handleDelete)
}

export const getInvoiceHitoricalTableColumns = (option) => {
    switch (option) {
        case "Maintenance":
            return MaintenanceTableColumns.ColumnsForInvoiceHistorical
        case "Indirect":
            return IndirectTableColumns.ColumnsForInvoiceHistorical
        case "Purchase":
            break;
        default:
            break;
    }
}

export const getInvoiceComplementTableColumns = (option) => {
    switch (option) {
        case "Maintenance":
            return MaintenanceTableColumns.ColumnsForInvoiceComplement
        case "Indirect":
            return IndirectTableColumns.ColumnsForInvoiceComplement
        case "Purchase":
            break;
        default:
            break;
    }

}

export const getRejectedInvoiceTableColumns = (option, DeleteRejectedInvoice) => {
    switch (option) {
        case "Maintenance":
            return MaintenanceTableColumns.ColumnsForRejectesInvoice(DeleteRejectedInvoice)
        case "Indirect":
            return IndirectTableColumns.ColumnsForRejectesInvoice(DeleteRejectedInvoice)
        case "Purchase":
            break;
        default:
            break;
    }
}

export const getConstantsPurchase = (option) => {
    switch (option) {
        case "OCCanceled":
            return 39
        case "OCRejected":
            return 7
        default:
            break
    }
}

export const getModalStyle = () => {
	const top = 50;
	const left = 50;

	return {
		top: `${top}%`,
		left: `${left}%`,
		transform: `translate(-${top}%, -${left}%)`,
	};
};